import React, { useContext, useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { AuthContext } from "../../authentication/AuthContext";

const SessionExpiryModal = () => {
  const { token, showExpiryWarning, dismissWarning, logout, checkTokenExpiry } =
    useContext(AuthContext);
  const [timeRemaining, setTimeRemaining] = useState(null);

  useEffect(() => {
    if (!showExpiryWarning || !token) return;

    // Initial calculation
    const updateTimer = () => {
      const { timeUntilExpiry } = checkTokenExpiry(token);
      const seconds = Math.floor(timeUntilExpiry / 1000);
      setTimeRemaining(Math.max(0, seconds));
    };

    updateTimer(); // Run immediately
    const interval = setInterval(updateTimer, 1000); // Then every second

    return () => clearInterval(interval);
  }, [showExpiryWarning, token, checkTokenExpiry]);

  const handleContinue = () => {
    dismissWarning();
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <Dialog
      open={showExpiryWarning}
      onClose={handleContinue}
      aria-labelledby="session-expiry-warning"
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
          border: "2px solid #ff6b6b",
        },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: "#ffebee",
          borderBottom: "1px solid #ffcdd2",
          py: 2,
        }}
      >
        <Box display="flex" alignItems="center">
          <Typography
            variant="h6"
            component="span"
            sx={{ color: "#d32f2f", fontWeight: "bold", display: "flex", alignItems: "center", gap: 1 }}
          >
            ⚠️ Session Expiring Soon!
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ py: 3 }}>
        <Typography variant="body1" sx={{ pd: 3, mb: 2, color: "#d32f2f" }}>
          Your session will expire in less than 1 minute. For security reasons,
          you'll be automatically logged out. Please click on continue to
          continue your session for 1 more minute.
        </Typography>

        <Box
          sx={{
            fontSize: "24px",
            fontWeight: "700",
            color: "#d32f2f",
            textAlign: "center",
            mt: 2,
            fontFamily: "monospace",
          }}
        >
          {timeRemaining !== null ? `${timeRemaining}s` : "..."}
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          py: 2,
          gap: 1,
          borderTop: "1px solid #ffcdd2",
        }}
      >
        <Button
          onClick={handleContinue}
          variant="outlined"
          sx={{
            borderColor: "#d32f2f",
            color: "#d32f2f",
            "&:hover": {
              borderColor: "#b71c1c",
              backgroundColor: "#ffebee",
            },
          }}
        >
          Continue for 1 more minute
        </Button>
        <Button
          onClick={handleLogout}
          variant="contained"
          sx={{
            backgroundColor: "#d32f2f",
            color: "white",
            "&:hover": {
              backgroundColor: "#b71c1c",
            },
          }}
        >
          Login Again
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiryModal;

